import React, { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import ResultLists from './ResultLists'
import ResultDetail from './ResultDetail'
import Pagination from "react-js-pagination"

const defaultpage = 1

const SearchResult = (props) => {
    const [resultdetailblkvisible, setResultdetailblkvisible] = useState(true)
    const[resdata,setResdata] = useState({
        recipesdata: props.resultdata
    })

    const showdetailBlk = (state) => {
        setResultdetailblkvisible(state)
    }
    /* Assign Variable for Pagination */
    const [currentPage, setCurrentPage] = useState(defaultpage)
    //Navigate to the page
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
        props.paginate(pageNumber)
    }

    const { t } = props;

    function showSblk(e){
        props.showresults(true)
    }

    return (        
        resultdetailblkvisible ?
        <>
        <div class="tool-mobile-header tool-mobile-header-recipe">
            {/* <div className="closelink" onClick={() => showSblk(this)}>X</div> */}
            {/* <h3>{t('RecipeFinder_SearchResults')}</h3> */}
            <span>
            {
                resdata.recipesdata.pagination ? 
                t('RecipeFinder_NoOfResults').replace('{0}',resdata.recipesdata.pagination.totalCount)  : 
                resdata.recipesdata.message
            } 
            </span>
            <div class="blk blk-btn">
                <a type="button" href="/en/recipe-finder" id="name-search-button" className="btn btn-p">Search Another Recipe</a>
            </div>
        </div>
        <div className="searchresult">
            <div className="countercontainer">                
                <h3>{t('RecipeFinder_SearchResults')}</h3>
                <div className="countdesc">                
                    {
                        resdata.recipesdata.pagination ? 
                        t('RecipeFinder_NoOfResults').replace('{0}',resdata.recipesdata.pagination.totalCount)  : 
                        resdata.recipesdata.message
                    }             
                </div>
            </div>
            {
                resdata.recipesdata.recipes && resdata.recipesdata.recipes.map((result, index) => {
                    return <ResultLists
                                key={index}
                                title={result.title}
                                href={result.detailLink}
                                shortdescription={result.summary}
                                thumbnail={result.thumbnail}
                                ingredients={result.keywords}
                                keywordlink={result.keywordLink}
                                //detailblk={showdetailBlk}
                            />
                })
            }            
            {
            resdata.recipesdata.pagination && resdata.recipesdata.pagination.totalCount > resdata.recipesdata.pagination.itemsPerPage  &&
                <Pagination
                    hideFirstLastPages
                    hideDisabled
                    //firstPageText='first'
                    //lastPageText='last'
                    activePage={props.currentpage}
                    itemsCountPerPage={resdata.recipesdata.pagination.itemsPerPage}
                    totalItemsCount={resdata.recipesdata.pagination.totalCount}
                    onChange={paginate}
                    prevPageText={<i className="fa fa-angle-left" aria-hidden="true"></i>}
                    nextPageText={<i className="fa fa-angle-right" aria-hidden="true"></i>}
                />
            }
        </div> 
        </>
        :
        <ResultDetail />
    );
};

export default withTranslation()(SearchResult);